import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { DialCodeData } from "@/types/dialcode";

export async function GetDialCode() {
  const { data } = await apiClient.post<ApiResponse<DialCodeData>>(
    "/api/AgentBookingHistory/get_dial_code",
    null,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get dial code request failed");
  }

  return data;
}